var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",class:{
    'button--secondary': _vm.variant === 'secondary',
    'button--disabled' : _vm.disabled,
    'button--error' : _vm.variant === 'error'
  },attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"click":_vm.onClickWrapper}},[(!_vm.isLoading)?_c('div',{staticClass:"button__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),(_vm.isLoading)?_c('b-spinner',{staticClass:"button__spinner",attrs:{"variant":"light","small":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }